import { Button } from '../../components'
import { theme } from '@utils'
import { StyleRow, StyleColumn } from './style'
interface PaginationProps {
  totalPages: number
  perPage?: number
  handleOnClick: (pageNumber: number) => void
  activePage: number
}
const Pagination = ({
  totalPages,
  handleOnClick,
  activePage,
}: PaginationProps) => {
  return (
    <StyleColumn customStyle={{ marginBottom: 15, marginTop: 15 }}>
      {totalPages > 1 && (
        <StyleRow customStyle={{ columnGap: 10, marginLeft: 'auto' }}>
          {activePage > 1 && (
            <Button
              height={20}
              title="Prev"
              onClick={() => {
                handleOnClick(activePage - 1)
              }}
            />
          )}
          {Array.from(
            { length: totalPages > 5 ? 5 : totalPages },
            (_, index) => index + 1,
          ).map((item: any, index: number) => {
            return (
              <StyleColumn
                key={index}
                customStyle={{
                  width: '40px',
                  cursor: 'pointer',
                  color:
                    activePage === index + 1
                      ? theme.colors.white
                      : theme.colors.primary,
                  background:
                    activePage === index + 1
                      ? theme.colors.primary
                      : theme.colors.primary50,
                  alignItems: 'center',
                  justifyContent: 'center',
                  paddingTop: 10,
                  paddingBottom: 10,
                  height: 20,
                  borderRadius: 4,
                }}
                onClick={() => {
                  handleOnClick(index + 1)
                }}
              >
                {index + 1}
              </StyleColumn>
            )
          })}
          {activePage > 5 && (
            <StyleColumn
              customStyle={{
                width: '40px',
                cursor: 'pointer',
                color: 'white',
                background: theme.colors.primary,
                alignItems: 'center',
                justifyContent: 'center',
                paddingTop: 10,
                paddingBottom: 10,
                height: 20,
                borderRadius: 4,
              }}
            >
              {activePage}
            </StyleColumn>
          )}
          {totalPages > 5 && (
            <StyleColumn customStyle={{ width: 80, height: 80 }}>
              <select
                style={{
                  height: 20,
                  borderRadius: 4,
                  border: '1px solid #ddd',
                }}
                onChange={(e) => {
                  handleOnClick(Number(e.target.value))
                }}
              >
                <option value="">Select</option>
                {Array.from(
                  { length: totalPages - 5 },
                  (_, index) => index + 1,
                ).map((item, index) => (
                  <option key={index} value={index + 6}>
                    {index + 6}
                  </option>
                ))}
              </select>
            </StyleColumn>
          )}
          {activePage < totalPages && (
            <Button
              height={20}
              title="Next"
              onClick={() => {
                handleOnClick(activePage + 1)
              }}
            />
          )}
        </StyleRow>
      )}
    </StyleColumn>
  )
}

export default Pagination
